import { Navigate, useRoutes } from 'react-router-dom';
import LoginForm from '../components/LoginForm';
import Profile from '../components/Profile';
import RegistrationFrom from '../components/RegistrationForm';
import RestoreForm from '../components/RestoreForm';
import RestorePasswordForm from '../components/RestorePasswordForm';
import { Context } from '..';
import { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import AllUsers from '../components/AllUsers';

const AppRoutes = () => {
  const { store } = useContext(Context)
  let routes = useRoutes([
    { path: "/", element: !store.isAuth ? <LoginForm /> : <Navigate to="/profile" /> },
    { path: "registration", element: !store.isAuth ? <RegistrationFrom /> : <Navigate to="/profile" /> },
    { path: "restore", element: !store.isAuth ? <RestoreForm /> : <Navigate to="/profile" /> },
    { path: "restore/:link", element: !store.isAuth ? <RestorePasswordForm /> : <Navigate to="/profile" /> },
    { path: "profile", element: !store.isAuth ? <Navigate to="/" /> : <Profile /> },
    { path: "all-users", element: !store.isAuth ? <Navigate to="/" /> : <AllUsers /> },
  ]);
  return routes;
};

export default observer(AppRoutes);